import React from 'react';
import '../login/LogInPage.js.css';
import '../styles/generics.css';
import logo from '../images/logo.png';
import bkg from '../images/main_background.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Button, Modal } from 'react-bootstrap';
import Connection from '../config/Connection';
import sha1 from 'crypto-js/sha1';
import AppStorage from '../config/AppStorage';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import MaskedInput from '../components/MaskedInput';
import Routes from '../config/Routes';
import { Link } from 'react-router-dom';

export default class LgpdAcceptPage extends PageComponent {

  static PageInfo = {
    show: false,

    path: "/lgpd",
    name: "menu.login",
    icon: "key",
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.selectedClient = null;
    this.state.error = null;
    this.state.cpf = null;
  }
  
  handleLogout() {
    AppStorage.ClearUserCredentials();
    this.props.history.push('/')
  }

setLgpd() {
  if(!this.props.history.location.state.lgpd.mainPersonCriticalValue) {
    this.props.history.location.state.lgpd.mainPersonCriticalValue = this.state.cpf
  }

  Connection.Secure(Connection.service + 'User/AddLgpd/',
    {
        "method": "POST",
        "headers": {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.props.history.location.state.lgpd)
    })
    .then((response) => {
        if (response.ok && response.status == 200) {
          AppStorage.SetUserCredentials(this.props.history.location.state.session, this.props.history.location.state.token);
          this.props.history.push('/')
          window.location.reload();
        }
        else console.log("response: ", response);
    })
      .catch((error) => {
        console.log("error: ", error);
      });
}

  render() {
    return (
        <div className="login_panel" >{
          Labels.GetLabel("states.msg").length > 0 ?
            <div className="login_panel_msg">{Labels.GetLabel("states.msg")}</div> : null}
          <div style={{ flex: 1, display: "flex", position: "relative" }}>
            <div className="login_panel_left" style={{ backgroundImage: 'url(' + bkg + ')' }}>
              <div className="login_panel_left_version">{Labels.GetLabel("generic.version")}: {Labels.GetLabel("version.current")}</div>
            </div>
            <div className="login_panel_right">
              <div style={{ flex: 1, minWidth: 20 }}></div>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
                <div className="login_panel_frame">
                  <div className="login_panel_logo">
                    <img className="login_panel_logo_image" src={logo} alt="LONGPING HIGH-TECH" />
                  </div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={"user-lock"} /> <span>LGPD</span></div>
                  <div>
                    <Form.Group onSubmit={(t) => this.setLgpd({ loading: true })}>
                        <MaskedInput type="text" icon="user" value={this.props.history.location.state.lgpd.mainPersonName} />
                        <MaskedInput type="email" icon="envelope" value={this.props.history.location.state.lgpd.mainPersonEmail} disabled />
                        <MaskedInput type="text" icon="id-card" onValid={(value) => this.setState({cpf: value})} value={this.props.history.location.state.lgpd.mainPersonCriticalValue} disabled />
                        <br />

                        <Button variant="success" block onClick={() => this.setLgpd()}>Autorizo o uso dos meus dados pessoais</Button>
                        <Button variant="danger" block onClick={() => this.handleLogout()}>Não autorizo o uso dos meus dados pessoais</Button>              
                    </Form.Group>
                  </div>
                </div>
              </div>
              <div style={{ flex: 1, minWidth: 20 }}></div>
            </div>
          </div>
        </div >
      );
   
  }

}